import { render, staticRenderFns } from "./SettingsAdmin.vue?vue&type=template&id=15b3f7eb&scoped=true"
import script from "./SettingsAdmin.vue?vue&type=script&lang=ts"
export * from "./SettingsAdmin.vue?vue&type=script&lang=ts"
import style0 from "./SettingsAdmin.vue?vue&type=style&index=0&id=15b3f7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3f7eb",
  null
  
)

export default component.exports